"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _muiThemeable = _interopRequireDefault(require("material-ui/styles/muiThemeable"));
require("./MenuItem.scss");
var _Dialog = _interopRequireDefault(require("../Dialog"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuItem, _React$Component);
  var _super = _createSuper(MenuItem);
  function MenuItem(props) {
    var _this;
    _classCallCheck(this, MenuItem);
    _this = _super.call(this, props);
    var activeNav = _this.props.activeNav.replace(/^\/|\/$/g, '').split('/')[0];
    var isActive = activeNav === _this.props.to || "/" + activeNav === _this.props.to;
    _this.state = {
      hover: false,
      isActive: isActive,
      modalOpen: false
    };
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.checkIfProceedToLink = _this.checkIfProceedToLink.bind(_assertThisInitialized(_this));
    _this.proceedToLink = _this.proceedToLink.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(MenuItem, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        hover: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        hover: false
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var activeNav = nextProps.activeNav.replace(/^\/|\/$/g, '').split('/')[0];
      var isActive = activeNav === nextProps.to || "/" + activeNav === nextProps.to;
      this.setState({
        isActive: isActive
      });
    }
  }, {
    key: "checkIfProceedToLink",
    value: function checkIfProceedToLink() {
      if (this.props.preventLink) {
        this.setState({
          modalOpen: true
        });
      } else {
        this.proceedToLink();
      }
    }
  }, {
    key: "proceedToLink",
    value: function proceedToLink() {
      this.closeModal();
      this.props.history.push(this.props.to);
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        modalOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var activeColor = this.props.muiTheme.palette.primary1Color;
      var activeStyles = {
        borderLeftColor: activeColor,
        color: activeColor
      };
      var isActive = this.state.isActive || this.state.hover;
      return /*#__PURE__*/_react["default"].createElement("div", {
        onMouseOver: this.handleMouseEnter,
        onMouseOut: this.handleMouseLeave,
        className: "menu-item  ".concat(this.state.isActive ? 'active' : ''),
        style: isActive ? activeStyles : null
      }, this.props.icon === 'exit-to-app' ? /*#__PURE__*/_react["default"].createElement("a", {
        href: window.location.origin
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: this.props.icon,
        color: isActive ? activeColor : this.props.iconColor,
        width: this.props.smallIcons ? 20 : 28,
        style: {
          "float": "left"
        },
        label: this.props.mode === 'large' ? '' : this.props.label
      }), this.props.mode === 'large' && this.props.label.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-label ".concat(this.props.smallIcons ? 'small-label' : '')
      }, this.props.label) : null) : /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.checkIfProceedToLink
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: this.props.icon,
        color: isActive ? activeColor : this.props.iconColor,
        width: this.props.smallIcons ? 20 : 28,
        style: {
          "float": "left"
        },
        label: this.props.mode === 'large' ? '' : this.props.label
      }), this.props.mode === 'large' && this.props.label.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-label ".concat(this.props.smallIcons ? 'small-label' : '')
      }, this.props.label) : null), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        content: this.props.preventLinkMessage,
        handleConfirm: this.proceedToLink,
        confirmLabel: "Exit without saving",
        handleCancel: this.closeModal,
        cancelLabel: "Cancel",
        modal: false,
        open: this.state.modalOpen,
        title: "You have unsaved changes"
      }));
    }
  }]);
  return MenuItem;
}(_react["default"].Component);
MenuItem.defaultProps = {
  activeNav: '',
  smallIcons: false,
  mode: 'large',
  preventLink: false,
  iconColor: 'rgba(255, 255, 255, 0.7)'
};
MenuItem.propTypes = {
  icon: _propTypes["default"].string,
  label: _propTypes["default"].string,
  to: _propTypes["default"].string,
  preventLink: _propTypes["default"].bool,
  preventLinkMessage: _propTypes["default"].string,
  mode: _propTypes["default"].oneOf(['large', 'small']),
  smallIcons: _propTypes["default"].bool,
  activeNav: _propTypes["default"].string,
  iconColor: _propTypes["default"].string
};

// export default MenuItem;
var _default = (0, _reactRouterDom.withRouter)((0, _muiThemeable["default"])()(MenuItem));
exports["default"] = _default;